export const TIME_INPUT_WIDTH = 35;
